import { AnmeldelseSkjemaBegrenset } from "@politiet/anmeldelse-lib/types/anmeldelseSkjemaBegrenset.typer";

import {
  Matrikkeladresse,
  Stedsnavn,
  Stedtype,
  Vegadresse,
} from "@politiet/anmeldelse-lib/types/anmeldelseUtkast.typer";
import { HandlingType } from "@politiet/anmeldelse-lib/types/anmeldelseSkjema.typer";
import { Handling } from "@politiet/anmeldelse-lib/types/anmeldelseSkjemaBegrenset.typer";
import {
  AnmeldelseType,
  DigaAnmeldelseBegrenset,
} from "@politiet/anmeldelse-lib/types/digaAnmeldelseBegrenset.typer";

export enum ErrorType {
  BAD_REQUEST = "BAD_REQUEST",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  SYSTEM_ERROR = "SYSTEM_ERROR",
}

export function isValidationError(
  errorDto: ErrorDTO,
): errorDto is ValidationErrorDTO {
  return errorDto.type === ErrorType.VALIDATION_ERROR;
}

export type ErrorDTO = {
  type: ErrorType;
  message: string;
};

export type ValidationErrorDTO = {
  errors: Array<ValidationError>;
} & ErrorDTO;

export const emptyValidationErrorDto: ValidationErrorDTO = {
  message: "",
  type: ErrorType.VALIDATION_ERROR,
  errors: [],
};

export type ValidationError = {
  property: string;
  message: string;
  messageParams?: Record<string, string>;
};

export type FrontendLogg = {
  message: string;
  stack: string;
  level: LoggLevel;
  status?: number;
  name: string;
  userAgent?: string;
};

export enum LoggLevel {
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
  DEBUG = "DEBUG",
  TRACE = "TRACE",
}

export type Page<T> = {
  pageIndex: number;
  totalPages: number;
  totalElements: number;
  totalElementsOnPage: number;
  elements: Array<T>;
};

export type AnmeldelseBegrensetInnsending = {
  kilde: "DIGA" | "SKJEMA";
  begrensetAnmeldelse?: AnmeldelseSkjemaBegrenset;
  digaAnmeldelse?: DigaAnmeldelseBegrenset;
  samtykkeVirksomhetKanSeAnmeldelsen: SamtykkeVirksomhetKanSeAnmeldelsen | null;
};

export enum SamtykkeVirksomhetKanSeAnmeldelsen {
  JA = "JA",
  NEI = "NEI",
}

export type FornaermetFregAdresse = {
  vegadresse?: Vegadresse;
  matrikkeladresse?: Matrikkeladresse;
  stedType?: Stedtype;
};

export type AnmeldelseKort = {
  id: string;
  innsendtTidspunkt: string;
  straffesaksnummer?: string;
  handlingstyper: SkjemaDigaHandlingType[];
  skjemaHandlingList?: Handling[];
  fornaermetType: string;
  fornaermetNavn?: string;
  kilde: "DIGA" | "SKJEMA";
};

export type SkjemaDigaHandlingType = HandlingType | AnmeldelseType;

export type StedResponseDto = {
  type: "VEGADRESSE" | "MATRIKKELADRESSE" | "STEDSNAVN";
  vegadresse?: Vegadresse;
  matrikkeladresse?: Matrikkeladresse;
  stedsnavn?: Stedsnavn;
  visningstekst: string;
};
